export default function TitleCompanySection() {
  const protections = [
    {
      icon: 'ri-file-search-fill',
      title: 'Title Search & Clearance',
      description: 'The title company conducts a comprehensive title search to identify any liens, judgments, or encumbrances. They ensure the title is clear before closing.'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Title Insurance',
      description: 'Title insurance protects all parties from future claims or defects in the title. This coverage provides peace of mind long after closing.'
    },
    {
      icon: 'ri-file-list-3-fill',
      title: 'Document Preparation',
      description: 'All legal documents are prepared correctly, including deeds, lease transfers, tenant notifications, and closing statements.'
    },
    {
      icon: 'ri-bank-fill',
      title: 'Escrow Services',
      description: 'Funds are held in escrow until all conditions are met. This ensures secure handling of money and protects both buyer and seller.'
    },
    {
      icon: 'ri-user-follow-fill',
      title: 'Tenant Lease Transfers',
      description: 'The title company manages all lease transfer paperwork, ensuring tenants receive proper legal notice and their rights are protected.'
    },
    {
      icon: 'ri-money-dollar-box-fill',
      title: 'Security Deposit Handling',
      description: 'Security deposits are properly transferred and documented according to Texas law, protecting both you and your tenants.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Title Company Protection for Every Transaction
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            When you sell tenant occupied property to us, every transaction is processed through a reputable title company. This ensures complete legal protection, proper documentation, and peace of mind for everyone involved.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/ac802fdb42d9aecb18922dd80e85df3a.jpg"
              alt="Title Company Protection"
              className="w-full h-auto rounded-lg shadow-2xl object-cover"
            />
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Why Title Company Closings Matter
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Using a title company isn't just a formality—it's essential protection when selling rental property with tenants. The title company acts as a neutral third party, ensuring all legal requirements are met and all parties are protected.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              This is especially important with tenant occupied real estate because there are additional complexities: lease transfers, tenant notifications, security deposit handling, and compliance with landlord-tenant laws.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We insist on title company closings for every transaction—no exceptions. This commitment to doing things the right way has earned us the trust of hundreds of landlords throughout El Paso.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {protections.map((protection, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${protection.icon} text-teal-600 text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{protection.title}</h3>
              <p className="text-gray-600 leading-relaxed">{protection.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-teal-50 border-l-4 border-teal-600 p-8 rounded-lg">
          <div className="flex items-start space-x-4">
            <i className="ri-shield-star-fill text-teal-600 text-4xl flex-shrink-0"></i>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Your Protection is Guaranteed</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                We've closed 100% of our transactions through title companies—over 200 rental property purchases totaling more than $120 million. This isn't just our policy; it's our commitment to doing business the right way.
              </p>
              <p className="text-gray-700 leading-relaxed">
                When you sell with tenants to T-Rex Real Estate, you can be confident that every legal requirement will be met, every document will be prepared correctly, and your interests will be fully protected.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}